import React from "react";
import { VR_RE_IMAGES } from "../../../data/vrRealEstateImages";

const CircularCityMap = ({ districts, selectedId, onSelectDistrict, onViewProperties }) => {
  const selected = districts.find((d) => d.id === selectedId) || districts[0];
  const preview = VR_RE_IMAGES[selected.previewKey] || VR_RE_IMAGES.mapTopDown;

  return (
    <section className="oshar-re-map" aria-labelledby="oshar-re-map-title">
      <div className="oshar-inner">
        <div className="oshar-re-map__head">
          <h2 id="oshar-re-map-title" className="oshar-re-section-title">
            Explore the Circular City
          </h2>
          <p className="oshar-re-section-lead">
            Select a district to preview placement, pricing bands, and supported asset types. Map
            interactions will deepen as the marketplace API ships.
          </p>
        </div>

        <div className="oshar-re-map__frame">
          <div className="oshar-re-map__chrome">
            <span className="oshar-re-map__chrome-dot" />
            <span className="oshar-re-map__chrome-dot" />
            <span className="oshar-re-map__chrome-dot" />
            <span className="oshar-re-map__chrome-label">Oshar cartography · Genesis overlay</span>
          </div>

          <div className="oshar-re-map__layout">
            <aside className="oshar-re-map__sidebar" aria-label="Districts">
              <p className="oshar-re-map__sidebar-title">Districts</p>
              <ul className="oshar-re-district-list">
                {districts.map((d) => (
                  <li key={d.id}>
                    <button
                      type="button"
                      className={`oshar-re-district-btn${selectedId === d.id ? " is-active" : ""}`}
                      onClick={() => onSelectDistrict(d.id)}
                    >
                      <span className="oshar-re-district-btn__ring" aria-hidden />
                      <span className="oshar-re-district-btn__label">{d.name}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </aside>

            <div className="oshar-re-map__center">
              <div className="oshar-re-map__image-wrap">
                <img src={VR_RE_IMAGES.mapTopDown} alt="Top-down circular map of Oshar" />
                <div className="oshar-re-map__hud" aria-hidden="true">
                  <span className="oshar-re-map__hud-pill">Layers</span>
                  <span className="oshar-re-map__hud-pill">Claims</span>
                </div>
                <div className="oshar-re-map__scanline" aria-hidden />
              </div>
            </div>

            <aside className="oshar-re-map__panel" aria-live="polite">
              <div className="oshar-re-map__panel-preview">
                <img src={preview} alt="" />
              </div>
              <h3 className="oshar-re-map__panel-title">{selected.name}</h3>
              <p className="oshar-re-map__panel-type">{selected.type}</p>
              <dl className="oshar-re-map__dl">
                <div>
                  <dt>Starting price</dt>
                  <dd>{selected.startingPrice}</dd>
                </div>
                <div>
                  <dt>Best for</dt>
                  <dd>{selected.bestFor}</dd>
                </div>
                <div>
                  <dt>Available property types</dt>
                  <dd>
                    <ul className="oshar-re-map__types">
                      {selected.propertyTypes.map((t) => (
                        <li key={t}>{t}</li>
                      ))}
                    </ul>
                  </dd>
                </div>
              </dl>
              <button type="button" className="oshar-btn-gold oshar-re-btn-block" onClick={onViewProperties}>
                View Properties
              </button>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CircularCityMap;
